import { useCallback, useRef } from 'react'

import { GLTFData } from '@components/adgroup-three-fiber/types'

type ModelGLTFData = Record<string, GLTFData>

interface UseVRAMTrackerArgs {
  activeModelId: string | undefined
}

const useVRAMTracker = ({ activeModelId }: UseVRAMTrackerArgs) => {
  const modelGLTFData = useRef<ModelGLTFData>()
  const activeModelGLTFData = activeModelId
    ? modelGLTFData.current?.[activeModelId]
    : undefined

  const setGLTFData = useCallback(
    (modelId: string) => (data: GLTFData) => {
      modelGLTFData.current = {
        ...modelGLTFData.current,
        [modelId]: data,
      }
    },
    []
  )

  return {
    activeModelGLTFData,
    setGLTFData,
  }
}

export default useVRAMTracker
